<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/colaborador/desafios'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de desafios"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode inscrever a sua equipe no desafio, todas as
              informações podem ser editadas novamente posteriormente.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-9">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    <i class="far fa-lightbulb mr-2"></i> Increver equipe no
                    desafio {{ desafio.title }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="vld-parent" ref="form_container">
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12">
                  <base-input
                    label="Nome da equipe*"
                    placeholder="Digite o nome"
                    v-model="model.name"
                  />
                </div>
                <div class="col-lg-12">
                  <base-input label="Descrição da equipe*">
                    <textarea
                      rows="2"
                      class="form-control"
                      placeholder="Descreva aqui a sua equipe"
                      v-model="model.description"
                    >
                    </textarea>
                  </base-input>
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">Integrantes</h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12 mb-4 pb-2">
                  <div class="vld-parent" ref="participants_form">
                    <label class="form-control-label d-block">
                      Integrantes da sua equipe
                    </label>
                    <multiselect
                      class="categories_select"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      track-by="name"
                      selectLabel="Clique para selecionar"
                      deselectLabel="Clique para remover"
                      placeholder="Busque por um colaborador (nome)"
                      label="name"
                      noResult="Nenhum resultado encontrado"
                      :options="participants"
                      v-model="selectParticipants"
                    >
                      <template slot="option" slot-scope="props">
                        <i class="fa fa-tag mr-2"></i>
                        {{ props.option.name }}
                        <span class="float-right text-xs">
                          {{ props.option.position }}
                        </span>
                      </template>
                      <span slot="noResult">Nenhum resultado encontrado</span>
                      <span slot="noOptions"
                        >Não há colaboradores cadastrados</span
                      >
                    </multiselect>
                  </div>
                </div>
              </div>
              <hr class="mt-5 mb-3" />

              <div class="row">
                <div class="col-12 text-center mt-3" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <div class="col-12 text-center mt-3">
                  <span
                    v-tooltip="
                      isValidModel
                        ? 'Clique para criar a equipe'
                        : 'Preencha os <b>campos obrigatórios</b> (<b>*</b>) para continuar'
                    "
                  >
                    <base-button
                      type="primary"
                      @click="handleSubmit()"
                      :custom="true"
                      :disabled="!isValidModel"
                    >
                      Inscrever equipe
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";
import Multiselect from "vue-multiselect";

export default {
  name: "enquetes-form",
  components: {
    multiselect: Multiselect
  },
  data() {
    return {
      model: {
        name: "",
        description: "",
        members: []
      },
      desafio: "",
      selectParticipants: [],
      participants: [],
      filterByParticipant: (option, search) => {
        const temp = search.toLowerCase();
        let match = false;
        return option.name.toLowerCase().indexOf(temp) > -1 || match;
      },
      error: ""
    };
  },
  async mounted() {
    await this.challengeLoad();
    await this.participantsLoad();
  },
  methods: {
    async challengeLoad() {
      const formLoader = this.$loading.show({
        container: this.$refs.form_container,
        width: 150,
        height: 150,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/collaborator/challenges/${this.$route.params.id}/public`
        );
        if (data) {
          this.desafio = data;
        } else this.empty = true;
        formLoader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar o desafio");
      }
    },
    async participantsLoad() {
      const selectLoader = this.$loading.show({
        container: this.$refs.participants_form,
        width: 150,
        height: 150,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/collaborator/challenges/${this.$route.params.id}/public/find-members`
        );
        if (data) {
          this.participants = data;
        } else this.empty = true;
        selectLoader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar os participantes");
      }
    },
    async handleSubmit() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 90,
        height: 90
      });
      try {
        const challenge = this.model;
        if (this.selectParticipants) {
          challenge.members_ids = this.selectParticipants.map(participant => {
            return participant.user_id;
          });
        } else challenge.members_ids = [];
        await api.post(
          `collaborator/challenges/${this.$route.params.id}/public/teams/`,
          {
            name: challenge.name,
            description: challenge.description,
            members: challenge.members_ids
          }
        );
        this.$toasted.show("Inscrição realizada com sucesso!");
        this.$router.push(`/colaborador/desafios`);
      } catch (e) {
        const strError =
          "Ocorreu um erro ao salvar a inscrição. Tente novamente.";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      loader.hide();
    }
  },
  computed: {
    isValidModel() {
      return (
        this.model.name && this.model.description && this.selectParticipants
      );
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}
.categories_select.multiselect {
  background-color: #fff;
  background-clip: padding-box;
}
.categories_select.multiselect .vs__dropdown-toggle {
  padding: 0.5rem 0.1rem;
  min-width: 100%;
}
</style>
